<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Create New Platform</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form @submit.prevent="submit" ref="newPlatformForm">
                    <b-row>
                        <!-- FIELD PLATFORM NAME -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Platform:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newPlatformName'"
                                >
                                <b-form-input
                                    v-model="new_platform.platform_name"
                                    type="text"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD PLATFORM CODE -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Platform Code:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newPlatformCode'"
                                >
                                <b-form-input
                                    v-model="new_platform.platform_code"
                                    type="text"
                                    required
                                    maxlength="4"
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Create</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>

    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { 
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Select } from "element-ui"
import '@/assets/js/formValidations.js'
import { EventBus } from "@/main"

export default {
    props:{
        create_platform: Boolean,
        hubList: Array,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Select.name]: Select,
        ValidationObserver,
        ValidationProvider,
    },    
    computed: {
        show: {
            get() {
                return this.create_platform;
            },
            set(newVal) {
                this.$emit('update:create_platform', newVal);
            },
        },
    },
    data() {
        return {
            new_platform: {
                platform_name: '',
                platform_code: '',
            },
        }
    },
    methods:{
        submit(){
            let form = new FormData()
            form.append('name',this.new_platform.platform_name)
            form.append('code',this.new_platform.platform_code)
            axios.post(services.lookup + 'platform', form, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                this.$emit('closeModal', false)
                EventBus.$emit('getAllPlatform')
                this.resetFormToNull(this.new_platform)
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>